import React from "react";
import Img from 'gatsby-image';
import Link from 'gatsby-link';
import styles from './journey.module.css';

export default ({ children, data }) => {
  return (
    <section>
      <Img
        className={styles.background}
        outerWrapperClassName={styles.background}
        sizes={data.frontmatter.image.childImageSharp.resolutions}
        />
      <div className={styles.container} >
        <h1><Link
          className={styles.title}
          to={data.fields.slug}
          >
          {data.frontmatter.title}
        </Link></h1>
        <p>{data.frontmatter.dates}</p>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/journey.js